module.exports = __webpack_public_path__ + "/login_ui/img/do-957628e87ccaf4af88c3a1546ffec2b7.svg";